import './assets/input-phone.css'
import { type Country, type Language, languageToCountryMap } from '@faceup/utils'
import { useContext } from 'react'
import ReactPhoneInput, { type PhoneInputProps } from 'react-phone-input-2'
import { twMerge } from 'tailwind-merge'
import { UiContext } from '../UiProvider/UiProvider'

// @ts-expect-error Hack due https://github.com/vitejs/vite/issues/4704
const PhoneInput: typeof ReactPhoneInput = ReactPhoneInput.default
  ? // @ts-expect-error Hack due https://github.com/vitejs/vite/issues/4704
    ReactPhoneInput.default
  : ReactPhoneInput

export type InputPhoneProps = {
  country?: Country | null
  'data-test'?: string
  language?: Language
} & Omit<
  PhoneInputProps,
  | 'inputClass'
  | 'enableSearch'
  | 'searchPlaceholder'
  | 'localization'
  | 'disableSearchIcon'
  | 'country'
>

const getDefaultCountry = (language?: Language): string | undefined => {
  // keep the original behavior when language not provided
  if (!language) {
    return undefined
  }

  // firstly try to match country by language (but language can be used in multiple countries)
  const countries = languageToCountryMap[language]
  if (countries[0] && countries.length === 1) {
    return countries[0].toLowerCase()
  }

  // fallback to basic inferring country from browser language
  const browserLanguageParts = navigator.language.split(/[_-]/)
  const inferredCountry =
    browserLanguageParts[2] ?? browserLanguageParts[1] ?? browserLanguageParts[0]
  return inferredCountry?.toLowerCase()
}

const InputPhone = ({ country, disabled, language, ...props }: InputPhoneProps) => {
  const { inputPhone } = useContext(UiContext)

  return (
    <PhoneInput
      {...inputPhone}
      {...props}
      disabled={disabled}
      inputProps={{
        'data-test': props['data-test'],
      }}
      country={country?.toLowerCase() ?? getDefaultCountry(language)}
      inputClass={`${twMerge('flex min-h-11 w-full gap-[10px] rounded-[12px] border-1 border-[#CDDDEE] pe-[11px] transition-all hover:border-[#007AE1] active:border-[#007AE1]', disabled && 'bg-[#9db0df14] text-[#92b4db] hover:border-[#cdddee]')}`}
      enableSearch
      disableSearchIcon
      onChange={(value, data, event, formattedValue) =>
        props?.onChange?.(value && `+${value}`, data, event, formattedValue)
      }
    />
  )
}

export default InputPhone
